import { AutocompleteRenderGetTagProps, Chip } from '@mui/material'
import { AssigneeAvatar } from './AssigneeAvatar'

interface AssigneeAutocompleteTagChipProps {
  option: { id: string; value: string }
  label: string
  getTagProps: AutocompleteRenderGetTagProps
  index: number
  isValid: boolean
  disabled?: boolean
  isExternal?: boolean
}

export const AssigneeAutocompleteTagChip = ({
  option,
  label,
  getTagProps,
  index,
  isValid,
  disabled,
  isExternal,
}: AssigneeAutocompleteTagChipProps) => {
  return (
    <Chip
      avatar={<AssigneeAvatar option={option} isExternal={isExternal} sx={{ marginLeft: 1 }} />}
      label={label}
      size="small"
      {...getTagProps({ index })}
      key={index}
      data-testid={`assignee-chip-${option.value}`}
      color={!isValid ? 'error' : 'default'}
    />
  )
}
